import React, { Children, cloneElement, isValidElement, useCallback, useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { Droppable } from 'react-beautiful-dnd';
import defaultTo from 'lodash/defaultTo';
import isFunction from 'lodash/isFunction';
import Icon from '../../../icon';
import TableContext from '../../TableContext';
const TreeNode = function TreeNode(props) {
    const { dataSet, prefixCls, columnsDragRender = {}, tableStore: { columnDraggable } } = useContext(TableContext);
    const { droppableProps, renderClone, renderIcon } = columnsDragRender;
    const selfPrefixCls = `${prefixCls}-combo-customization-tree-treenode`;
    const { renderer, suffix, children, className, isLeaf, hidden, record, index, records, provided, snapshot } = props;
    const sort = record.get('sort');
    const isExpanded = defaultTo(record.getState('expanded'), true);
    const [expended, setExpanded] = useState(isExpanded);
    const [isHover, setIsHover] = useState(false);
    const toggleExpanded = useCallback(() => {
        record.setState('expanded', !isExpanded);
        if (!expended) {
            setExpanded(true);
        }
    }, [record, isExpanded, expended]);
    const handleMouseEnter = useCallback(() => setIsHover(true), []);
    const handleMouseLeave = useCallback(() => setIsHover(false), []);
    const { isDragging } = snapshot || {};
    useEffect(() => {
        setIsHover(false);
    }, [sort]);
    function renderSwitcherIcon() {
        return !isLeaf && (React.createElement(Icon, { type: "expand_more", className: classNames(`${selfPrefixCls}-switcher-icon`, { [`${selfPrefixCls}-switcher-icon-close`]: !isExpanded }), onClick: toggleExpanded }));
    }
    function renderChildren() {
        return Children.map(children, child => isValidElement(child) ? cloneElement(child, {
            hidden: hidden || !isExpanded,
        }) : child);
    }
    function getIcon() {
        if (provided) {
            const iconProps = { ...provided.dragHandleProps, style: { cursor: 'move' } };
            if (isFunction(renderIcon)) {
                const icon = renderIcon({ dataSet, column: record.toData(), snapshot });
                if (isValidElement(icon)) {
                    return cloneElement(icon, iconProps);
                }
                return icon;
            }
            return (React.createElement(Icon, Object.assign({ className: `${selfPrefixCls}-drag-icon`, type: "baseline-drag_indicator" }, iconProps)));
        }
    }
    return (React.createElement("div", Object.assign({ ref: provided && provided.innerRef }, (provided && provided.draggableProps), { className: classNames({ [`${selfPrefixCls}-dragging`]: isDragging }) }),
        React.createElement("div", { className: classNames(selfPrefixCls, className, { [`${selfPrefixCls}-hover`]: isHover }), style: { display: hidden ? 'none' : '' }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
            React.createElement("div", { className: classNames({ [`${selfPrefixCls}-content`]: true, [`${selfPrefixCls}-content-hidden`]: record.get('hidden') }) },
                getIcon(),
                React.createElement("div", { className: `${selfPrefixCls}-title` },
                    React.createElement("span", { className: `${selfPrefixCls}-title-text` }, renderer(record, provided)),
                    React.createElement("span", { className: classNames(`${selfPrefixCls}-switcher`, { [`${selfPrefixCls}-switcher-noop`]: isLeaf }) }, renderSwitcherIcon())),
                suffix(record, index, records))),
        columnDraggable ? (React.createElement(Droppable, Object.assign({ droppableId: `treenode__--__${record.key}`, key: "treenode", renderClone: renderClone ? (cloneProvided, cloneSnapshot, rubric) => renderClone({ provided: cloneProvided, snapshot: cloneSnapshot, rubric }) : undefined }, droppableProps), (droppableProvided) => (React.createElement("div", Object.assign({ style: { paddingLeft: 15 }, ref: droppableProvided && droppableProvided.innerRef }, (droppableProvided && droppableProvided.droppableProps)),
            expended && renderChildren(),
            droppableProvided && droppableProvided.placeholder)))) : (React.createElement("div", { style: { paddingLeft: 15 } }, expended && renderChildren()))));
};
TreeNode.displayName = 'TreeNode';
export default observer(TreeNode);
